const advertise = {
    dfdh: '相手の電話番号:',
    sjmc: '事業者名',
    qsrsj: '事業者名を入力してください',
    sjbzj: '事業者の保証金',
    wcl: '30日の完了率',
    zcd: '総成約数（買/売）',
    cd: '30日の成約数',
    c: '回',
    fz: '分',
    pjfx: '平均リリース',
    zcsj: '登録時間：',
    fbjy: '初回法定通貨取引へのアクセス:',
    yxbd: 'メールアドレスを登録',
    sjbd: '電話番号を登録',
    cjsm: '初級本人確認',
    gjsm: 'ハイレベル本人確認',
    buy: '購入',
    sell: '売却',
    market: '市場',
    djfs: '価格設定方法',
    ggid: '広告ID',
    time: '時間',
    type: 'タイプ',
    ptgg: '通常広告',
    gdjg: '固定価格',
    fdjg: '変動価格',
    yjfw: 'オーバープレミアム範囲',
    unitPrice: '単価',
    totalPrice: '合計金額',
    sysl: '残り数量',
    ywcsl: '完了数量',
    cz: '操作',
    xj: '下げる',
    sj: '出品をする',
    edit: '編集',
    delete: '削除',
    all: '全て',
    qdxjm: 'この広告を下げてもよろしいですか？',
    qdxj: '下げることを確認する',
    qdsjm: 'この広告を出品してよろしいですか？',
    qdsj: '出品する',
    confirm: '確認',
    cancel: 'キャンセル',
    qdscm: 'この広告を削除してもよろしいですか？',
    deleteAdvertise: '広告を削除',
    
    tjgm: '購入統計',
    tjcs: '販売統計',
    coins: 'コイン',
    day7: '7日',
    day15: '15日',
    day30: '30日',
    tj: '統計',
    mrsl: '購入数量',
    mcsl: '売却数量',
    mrjj: '平均購入価格',
    mcjj: '平均売却価格',
    zcje: '支出額',
    srje: '収入額',
    zsxf: '総手数料',
    cjdd: '約定注文',
    zdxx: '明細情報',
    tips: 'お知らせ：各取引ペアごとに、購入および売却統計は1日につき最大100回ずつのみエクスポートできます',
    dcdd: '注文をエクスポート',
    orderNo: '注文番号',
    jybz: '取引コイン',
    number: '数量',
    total: '合計',
    fee: '手数料',
    zd: '明細',
    
    tjskfs: '受け取り方法を追加',
    skfs: '受け取り方法',
    name: '名前',
    payAccount: '口座',
    sk: '受け取り',
    cz: '操作',
    delete: '削除',
    edit: '編集',
    qdsc: '削除してもよろしいですか？',
    tip: 'お知らせ',
    deleted: '削除がキャンセルされました',
    xzskfstt: '新しい受け取り方法を追加',
    xgskfstt: '受け取り方法を変更',
    khmc: '口座名義',
    yhkh: '銀行カード番号',
    khh: '銀行名',
    khhszd: '銀行所在地',
    khhmc: '銀行支店名',
    wxzh: 'WeChatアカウント',
    zfbzf: 'Alipay支払い',
    ewmsc: 'QRコードをアップロード',
    jymm: '取引パスワード',
    srkhh: '銀行名を入力してください',
    xzszd: '銀行所在地を選択してください',
    srkhmc: '銀行支店名を入力してください',
    srzh: 'アカウントを入力してください',
    scskm: '受け取りコードをアップロードしてください',
    srjymm: '取引パスワードを入力してください',
    scwjgd: 'プロフィール画像のアップロードサイズは2MBを超えてはいけません！',
    
    jnbzj1: 'あなたは{gradeName}として、保証金{margin} USDTを支払いました。現在の残高は{amount} USDTです',
    k: '利用可能',
    add: '追加',
    or: 'または',
    reduce: '減らす',
    margin: '保証金',
    sqsxf: '*プラットフォームは、取引完了額の{fee}%を手数料として事業者からいただきます',
    hqed: '今すぐに認証事業者になって、より高い上限額を獲得する',
    want: '私はしたい',
    bb: '現物',
    price: '価格',
    ckj: '*市場参考価格{price} {fiatCurrency}/USDT 固定価格は市場の変動に影響されません',
    jyjg: '取引価格',
    mdjg: 'アンカー価格',
    gxhl: '*メガバンク銀行および複数の取引所のリアルタイム為替レート、5分ごとに更新',
    szyj: 'オーバープレミアム設定',
    zjjy: '*負の数値を入力できます。固定価格を基準にディスカウントで取引します',
    yjsz: '取引価格=固定価格（1+オーバープレミアム設定）',
    jyxz: '取引制限',
    jysl: '取引数量',
    sygged: '*取引数量は残り広告額を超えてはいけません',
    zxxe: '最小取引限度額',
    zdxe: '最大取引限度額',
    fkqx: '支払い期限',
    xnfk: '*この期間内に支払う必要があります',
    fkfs: '支払い方法',
    xzskfs: '*すべてのコインの最大受け取り方法は5つまで追加できます',
    yhjy: 'ハイレベル本人確認が未完了のユーザーとの取引できません',
    jygg: '*初級本人確認のみを行ったユーザーは取引広告に参加できません',
    cyjy: '指定された購入回数を達していないユーザーを選択してください。取引に参加できません',
    bmfx: '*購入を完了したユーザーは、出所不明資金のリスクを大幅に減少することになります',
    qxz: '選択してください',
    jybz: '取引備考',
    tyzs: '私は理解し、遵守することに同意します',
    jygz: '取引ルール',
    yzm: '認証コード',
    save: '保存',
    fbgg: '広告を掲載',
    jsbzjcg: '保証金減額成功',
    zjbzjcg: '保証金追加成功',
    xzfs: '受け取り方法または支払い方法を選択してください',
    bankTip1: '銀行カードは3つ以上の受け取り方法を追加できません',
    wxTip2: 'WeChatは3つ以上の受け取り方法を追加できません',
    zfbTip3: 'Alipayは3つ以上の受け取り方法を追加できません',
    syjg: '価格を入力してください',
    syjysl: '取引数量を入力してください',
    zxxe: '最小取引限度額を入力してください',
    zdxe: '最大取引限度額を入力してください',
    fkqx: '支払い期限を入力してください',
    tyjygz: '取引ルールに同意してください',
    tpyzm: '画像認証コードを入力してください',
    jydx: '取引相手',
    
    zjbzj: '保証金追加',
    jsbzj: '保証金減額',
    xzdgged: '現在の最大広告限度額',
    zjbzjse: '保証金追加金額',
    jsbzjse: '保証金減額金額',
    zjhbzjed: '追加後の保証金額',
    jshbzjed: '減少後の保証金額',
    balance: '残高',
    sy: '残り',
    kzj: '追加可能',
    kjs: '減少可能',
    otcsjxy: 'OTC事業者サービス規則契約',
    xsgz: '初心者向けチュートリアル',
    jygz: '取引ルール',
    jnbzj: 'OTCが合法かつ規約の下に行うるよう、また、関係者の行動を制約するため、事業者に一定の保証金を支払って頂きます。',
    zjjnbzj: '保証金は基本限度額と追加限度額の2つの部分で構成され、基本限度額は必須の部分で、追加部分は支払うかどうかを選択できます。',
    kxs: '基本限度額を支払うと、',
    fbgged: '（CNYTをリリースする場合、為替レートで計算）の広告限度額が得られます。',
    ggedbl: '追加部分の保証金と広告限度額の比率は',
    eg: '100 USDTを追加する場合、広告限度額は基本限度額に100 x追加されます。',
    ggzedjs: '広告の総限度額は次の式で計算されます：基本広告限度額+追加広告限度額 x',
    ttsjzxed: '一般事業者の追加保証金の最小額は',
    zdedw: '最大額は',
    mgsjzd: '各事業者は最大で購入広告3件と販売広告3件を投稿できます。',
    hljj: 'USDTをCNYTに交換する為替レートは、BiKingプラットフォームの関連する取引ペアの過去24時間の平均価格（1時間ごとに記録し、最高価格と最低価格を除く）を使用して計算されます。また、為替レートが変動する場合、元々の投稿された広告限度額は変わりません。',
    jcbzj: '基本保証金',
    xt: '任意',
    njhded: '得られる広告限度額は次のとおりです：',
    mbye: '買い残高：',
    zhzcbz: '口座残高が不足しています。資産口座から振替できます。',
    qhz: '振替する',
    qdjnbzj: '基本保証金を支払うことを確認します',
    tjbzj: '保証金を追加',
    sqsjcg: '事業者申請成功',
    exchange:'為替レート変換'
    
}
export {
    advertise
}


// WEBPACK FOOTER //
// ./src/i18n/lang/advertise/ja_JP.js